module.exports = __webpack_public_path__ + "img/circleLight.53cde31f.png";